module.exports = __webpack_public_path__ + "img/attendance_summary-blue.8bef7a58.svg";